export const ProgramNotStarted = {
  transclude: true,

  bindings: {
    hasStarted: '<',
  },

  template: `
    <div class="program-not-started">
      <div class="overlay text-center" ng-if="!$ctrl.hasStarted">
        <div class="container">
          <div class="col-md-6 mx-auto">
            <h5>Ready to start?</h5>
            <p class="my-3">
              Ready to start? Press start to access your workouts and meal plans.
            </p>
            <button class="btn btn-pill btn-lg theme-btn w-100"
              data-toggle="modal"
              data-target="#modalStartProgram">
              <span class="font-weight-bold text-uppercase">
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                Start your program
                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="content" ng-transclude></div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Program/ProgramNotStarted.js